import {

  CORE_LOAD_ALLFLOOR_REQUEST,
  CORE_LOAD_ALLFLOOR_SUCCESS,

  CORE_LOAD_FLOORINFO_REQUEST,
  CORE_LOAD_FLOORINFO_SUCCESS,

  CORE_SEARCH_FLOOR_REQUEST,
  CORE_SEARCH_FLOOR_SUCCESS,

} from '../../../types'

const initialState = []
export default {
  floor: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_ALLFLOOR_REQUEST:
      case CORE_SEARCH_FLOOR_REQUEST:
        return initialState

      case CORE_LOAD_ALLFLOOR_SUCCESS:
      case CORE_SEARCH_FLOOR_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
  floorInfo: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_FLOORINFO_REQUEST:
        return initialState
      case CORE_LOAD_FLOORINFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  },
}


// WEBPACK FOOTER //
// ./src/features/location/floor/reducer.js